module.exports = __webpack_public_path__ + "static/media/d1ru.8fb23012.pdf";